import React from 'react';
import { Typography } from 'antd';
import { FelaStyle } from 'src/fela';
import { useFela } from 'react-fela';
import { useTranslation } from 'react-i18next';
import myworkLogo from '../../../../../../assets/images/mywork logo whitebg rect retina transp.png';
import MedicalCertificate from '../../../../../../assets/images/documents/medical-certificates/medicalCertificateBlackAndWhite.svg';

const { Text } = Typography;

export default function UploadCertificateForbidden() {
  const { css } = useFela();
  const { t } = useTranslation();

  return (
    <div className={css(styles.container)}>
      <img
        src={myworkLogo}
        alt={t('commons.myworkLogoAlt')}
        className={css(styles.myworkLogo)}
        data-testid="mywork-logo"
      />
      <MedicalCertificate
        className={css(styles.medicalCertificate)}
        data-testid="medical-certificate-image"
      />
      <Text className={css(styles.forbiddenText)}>
        {t('medicalCertificates.uploadByEmployee.forbidden.text')}
      </Text>
    </div>
  );
}

const styles: FelaStyle = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  myworkLogo: {
    width: '12rem',
    marginBottom: '4rem',
  },
  medicalCertificate: {
    maxWidth: '7rem',
    marginBottom: '1.5rem',
  },
  forbiddenText: {
    fontSize: '1rem',
    textAlign: 'center',
    color: '#000000',
    fontWeight: '500',
    lineHeight: '1.5rem',
  },
};
